export function feature_js_resizable(el) {
    $(el.find(".modal-content").get(0)).resizable();
}